const drawerWidth = 400;

export const rightSideDrawerStyles = {
  width: drawerWidth,
  flexShrink: 0,
  "& .MuiDrawer-paper": {
    width: drawerWidth,
  },
  paddingTop: 2,
};
